import React, { useState, useEffect } from 'react';
import { Col, Container, Dropdown, Image, Navbar, Row, Alert } from 'react-bootstrap';
import { logout } from '../../services/util/auth';
import styles from './mySettings.module.scss';
import { useNavigate } from 'react-router-dom';
import UserInfo from './userInfo';
import CalendarSettings from './calendarSettings';
import CustomNavbar from '../adminPanel/customNavbar';
import CustomerSupport from './customerSupport';
import { getUserAlerts } from '../../services/util/userNotification';
import {
    Route,
    Routes,
    Navigate,
    NavLink
} from 'react-router-dom';

function MySettings(props) {

    const history = useNavigate();

    let [userAlerts, setUserAlerts] = useState({
        total_alert_count: 0,
        overall_alart_type: 0,
        alerts: []
    });

    const dropdownSelect = (e) => {
        if (e === '1') {
            history("/my-settings")
        }
        if (e === '2') {
            history("/my-settings/customer-support")
        }
        if (e === '3') {
            logout()
            history("/signin")
        }
    }

    function goToAlertLink(value) {
        if (value === 1001) {
            window.location.replace('/app/company/settings/integrations')
        }
        if (value === 1002) {
            window.location.replace('/app/my-settings/calendar')
        }
    }

    const goToSupportPage = () => {
        history("/my-settings/customer-support")
    }

    const GetUserAlerts = async () => {
        let respond = await getUserAlerts();
        if (respond.success) {

            let userAlerts = {
                total_alert_count: respond.data.total_alert_count,
                overall_alart_type: respond.data.overall_alerts_type,
                alerts: respond.data.user_alerts
            }

            setUserAlerts(userAlerts);
        }
    }

    useEffect(() => {
        GetUserAlerts();

        const interval = setInterval(() => {
            GetUserAlerts();
        }, 600000); // refresh alerts in 10mins intervals

        return () => clearInterval(interval);
    }, []);

    const CustomAlertToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.alertBox}>
                {userAlerts.total_alert_count > 0 && <div className={(userAlerts.overall_alart_type === -20) ? styles.alertCountDangerIndicator : userAlerts.overall_alart_type === -10 ? styles.alertCountWarningIndicator : styles.alertCountDefaultIndicator}>{userAlerts.total_alert_count}</div>}

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </a>
    ));

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="23" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" />
                        <circle cx="24" cy="24" r="23" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" />
                        <path d="M23.9999 22.584C27.5378 22.584 30.4166 19.7052 30.4166 16.1673V15.0007C30.4166 11.4627 27.5378 8.58398 23.9999 8.58398C20.462 8.58398 17.5833 11.4627 17.5833 15.0007V16.1673C17.5833 19.7052 20.462 22.584 23.9999 22.584Z" fill="#2DA6C0" fillOpacity="0.75" />
                        <path d="M32.9122 26.1926C30.9568 25.611 27.8232 24.918 24 24.918C20.1768 24.918 17.0432 25.611 15.0878 26.1926C13.0917 26.7864 11.75 28.5848 11.75 30.6673V34.8346C11.75 35.1566 12.0113 35.418 12.3333 35.418H35.6667C35.9887 35.418 36.25 35.1566 36.25 34.8346V30.6673C36.25 28.5848 34.9083 26.7864 32.9122 26.1926Z" fill="#2DA6C0" fillOpacity="0.75" />
                    </svg>
                </div>
                <div className={styles.arrowIconSvgDiv}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    return (
        <div className={styles.mainContainer}>
            <div className={styles.topNavComponent}>
                <Navbar expand="lg" className={styles.navbar}>
                    <div className="me-auto">
                        <div className={styles.companyLogoContainer}>
                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/companylogo.png`} fluid />
                        </div>
                    </div>
                    <div className='me-3'>
                        <Dropdown
                            onSelect={(e) => dropdownSelect(e)}
                        >
                            <Dropdown.Toggle as={CustomAlertToggle}></Dropdown.Toggle>

                            <Dropdown.Menu className={styles.alertDropdownMenu} align="end">
                                <div className={styles.alertDropdownMenuArrowUp}></div>
                                {(userAlerts.alerts).length > 0 ?
                                    (userAlerts.alerts).map((value, index) => (
                                        <Alert key={"light"} variant={"light"} className={styles.alertMessage}>

                                            <div className={styles.alertMessageIconBox}>
                                                <svg
                                                    className={`
                                                        ${value.alert_type === 0 && styles.defaultAlertIcon}
                                                        ${value.alert_type === -10 && styles.warningAlertIcon}
                                                        ${value.alert_type === -20 && styles.dangerAlertIcon}
                                                    `}
                                                    width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12 8V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12 16H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div className={styles.alertMessageTextBox}>
                                                <p className={styles.alertMessageText}>{value.message}. {value.alert_code === 1001 || value.alert_code === 1002 ? <a onClick={() => goToAlertLink(value.alert_code)} className={styles.alertMessageLink}>Fix it</a> : null}</p>
                                            </div>
                                        </Alert>
                                    )):
                                    <div><p className={styles.noNotificationsications}>You have no notifications</p></div>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className={styles.userDetails}>

                        <p className={styles.currentUserName}>{localStorage.getItem("name")}</p>
                        <Dropdown
                            alignRight={true}
                            onSelect={(e) => dropdownSelect(e)}
                        >
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            </Dropdown.Toggle>

                            <Dropdown.Menu className={styles.dropdownMenu} align="end">
                                <div className={styles.userDetailsBox}>
                                    <div className={styles.userAvatarContainer}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/navigation_dropdown_avatar.png`} fluid className={styles.userAvatar} />
                                    </div>
                                    <div className={styles.userDetailsContainer}>
                                        <p className={styles.userDetailsTopic}>{localStorage.getItem("name")}</p>
                                    </div>
                                </div>
                                <Dropdown.Item eventKey="1" className={styles.dropdownText}><i className={`${styles.changePasswordIcon} ${"fas fa-cog"}`}></i>My Settings</Dropdown.Item>
                                <Dropdown.Item eventKey="2" className={styles.dropdownText}><i className={`${styles.signoutIcon} ${"fas fa-question-circle"}`}></i>Help</Dropdown.Item>
                                <Dropdown.Item eventKey="3" className={styles.dropdownTextLogout}><i className={`${styles.signoutIcon} ${"fas fa-sign-out-alt"}`}></i>Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Navbar>
            </div>
            <div className={styles.bodyContainer}>
                <Row className=".ms-0 me-0">
                    <Col xs={5} lg={4} xl={3} className={styles.topicSideColumn}>
                        <Container>
                            <p className={styles.pageTopic}>My Settings</p>
                            <div>
                                <NavLink to="/company" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 8L8 12L12 16" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16 12H8" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Back to Dashboard</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/user-info" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M23.3334 24.5V22.1667C23.3334 20.929 22.8417 19.742 21.9666 18.8668C21.0914 17.9917 19.9044 17.5 18.6667 17.5H9.33341C8.09574 17.5 6.90875 17.9917 6.03358 18.8668C5.15841 19.742 4.66675 20.929 4.66675 22.1667V24.5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.9999 12.8333C16.5772 12.8333 18.6666 10.744 18.6666 8.16667C18.6666 5.58934 16.5772 3.5 13.9999 3.5C11.4226 3.5 9.33325 5.58934 9.33325 8.16667C9.33325 10.744 11.4226 12.8333 13.9999 12.8333Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>User Info</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/calendar" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer} >
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.1667 4.66699H5.83333C4.54467 4.66699 3.5 5.71166 3.5 7.00033V23.3337C3.5 24.6223 4.54467 25.667 5.83333 25.667H22.1667C23.4553 25.667 24.5 24.6223 24.5 23.3337V7.00033C24.5 5.71166 23.4553 4.66699 22.1667 4.66699Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M18.6665 2.33301V6.99967" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.3335 2.33301V6.99967" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M3.5 11.667H24.5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Calendar Settings</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/customer-support" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3">
                                            </path><line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Customer Support</span>
                                </NavLink>
                            </div>
                        </Container>

                    </Col>
                    <Col sm={7} lg={8} xl={9}>
                        <Container className={styles.mySettingsBody}>
                            <Routes>
                                <Route path='/user-info' element={<UserInfo {...props} />} />
                                <Route path='/calendar' element={<CalendarSettings {...props} />} />
                                <Route path='/customer-support' element={<CustomerSupport {...props} />} />
                                <Route index element={<Navigate replace to="/my-settings/user-info" />} />
                            </Routes>
                        </Container>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default MySettings;
